/**
 * "N characters left" under a single-line input with a hard cap.
 *
 * Same treatment as the Save view title in Triage (`save-view-modal.tsx`):
 * a small line in the normal flow below the field, so it never overlaps
 * the next row's label the way the floating `hint` does, turning red when
 * the cap is reached. When the field has a validation error, the error
 * text takes the line instead.
 */
import { cx } from "@tricura/atlas-ui";
import { charactersLeft } from "../utils/field-limits";

interface CharCountHintProps {
    value: string | null | undefined;
    maxLength: number;
    /** Validation message; shown in place of the counter when present. */
    error?: string;
}

export function isAtLimit(value: string | null | undefined, maxLength: number): boolean {
    return (value?.length ?? 0) >= maxLength;
}

export function CharCountHint({ value, maxLength, error }: CharCountHintProps) {
    const red = Boolean(error) || isAtLimit(value, maxLength);
    return <p className={cx("mt-1.5 text-xs", red ? "text-error-primary" : "text-tertiary")}>{error ?? charactersLeft(value, maxLength)}</p>;
}
